import { motion } from '@/components/framer-motion'

export function PageTransition({ children }: { children: React.ReactNode }) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
      // min-w-0 lets pages with wide scrollable content (tables, calendars)
      // shrink to the pane instead of blowing out the whole layout's width.
      className="flex-1 min-w-0"
    >
      {children}
    </motion.div>
  )
}
